import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer, PropTypes as MobxPropTypes} from 'mobx-react';
import * as mobx from 'mobx'

import {SearchToSelect} from "../../components";

import AccountsStore from './AccountsStore';

@observer
class AccountSelector extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    selected: MobxPropTypes.arrayOrObservableArray,
    onSelect: PropTypes.func.isRequired,
    multi: PropTypes.bool,
    disabled: PropTypes.bool,
    accountsStore: PropTypes.instanceOf(AccountsStore)
  };

  constructor(props){
    super(props);
  }

  componentWillMount(){
    if (!this.props.accountsStore.loaded) {
      this.props.accountsStore.loadAccounts();
    }
  }

  render() {
    //for some reason placeholder was one draw behind
    const {selected, multi, disabled} = this.props;
    let placeholder;
    if(multi && selected && selected.length){
      // Multi select displays number of selections
      placeholder = `${selected.length} Selections`;
    } else if (!multi && selected && selected.length === 1) {
      // Single select displays selected account name
      const accounts = mobx.toJS(this.props.accountsStore.accounts);
      const maybeAccount = accounts.find(account => account.id === selected[0])
      placeholder = maybeAccount && maybeAccount.accountName;
    }

    return (
      <SearchToSelect
        multi={multi}
        disabled={disabled}
        getKey={acct => acct.id}
        selectByKey
        options={this.props.accountsStore.accounts}
        renderOption={acct => acct.accountName}
        placeholder={this.props.placeholder || placeholder || (!!multi ? "Accounts" : "Account")}
        onSelected={this.props.onSelect}
        getSearchResults={({query}) => this.props.accountsStore.search(query)}
        selected={selected}
      />
    );
  }
}

AccountSelector.defaultProps = {
  multi: true, // Multi select by default
  disabled: false,
  accountsStore: new AccountsStore()
};

export default AccountSelector;